import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import Axios from "axios";
import vuetify from "@/plugins/vuetify"; // path to vuetify export
import VueClipboard from "vue-clipboard2";
const { QRCanvas } = require("qrcanvas-vue");

Vue.config.productionTip = false;

Axios.defaults.baseURL = process.env.VUE_APP_API_URL;

Vue.use(VueClipboard);

new Vue({
  QRCanvas,
  vuetify,
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");

if (process.env.NODE_ENV == "development") {
  Vue.config.devtools = true;
  Vue.config.debug = true;
  Vue.config.silent = false;
} else {
  Vue.config.devtools = false;
  Vue.config.debug = false;
  Vue.config.silent = true;
}
